export { GRID_DETAILS_SERVICE_NAME, GRID_DETAILS_SERVICE_PROVIDER_NAME, GridDetailsService, GridDetailsServiceProvider } from './grid-details.service'

export { GRID_DETAILS_SERVICES_MODULE_NAME } from './grid-details.services.module'